import { AxiosResponse } from 'axios';
import { Interest } from './Interest';
import VersionedResource from '../VersionedResource';

export default class InterestSettingsResource extends VersionedResource {
  public async get(fiId: number) : Promise<Interest> {
    const url = `/api/rcx/config/${fiId}/interest`;
    try {
      const response: AxiosResponse = await this.apiClient.get(url);
      return response.data.data;
    } catch (error) {
      // Will 404 if processing days has not been set up yet, so return empty processing days
      if (error.response.status !== 404) {
        throw error;
      } else {
        return {
          coreInterestRateCalculation: '',
          balanceType: '',
          calculationMethod: '',
          compoundingMethod: '',
          roundingMethod: '',
          roundingDecimalPlaces: undefined,
          coreNonProcessingAccrualMethod: null,
          observeLeapYear: undefined,
        };
      }
    }
  }

  public async update(fiId: number, data:Interest): Promise<Interest> {
    const url = `/api/rcx/config/${fiId}/interest`;
    const response: AxiosResponse = await this.apiClient.put(url, data);
    return response.data.data;
  }
}
